<mat-form-field appearance="outline" floatLabel="always">
  <mat-label *ngIf="label">{{ label }}</mat-label>
  <mat-select
    [placeholder]="placeholder"
    [formControl]="myControl"
    [disabled]="isDisabled"
    [tabIndex]="tabIndex"
  >
    <mat-option value="">{{ placeholder }}</mat-option>
    <mat-option *ngFor="let state of options" [value]="state.code">
      <ng-container *ngIf="display === 'code'">{{ state.code }}</ng-container>
      <ng-container *ngIf="display === 'label'">{{ state.label }}</ng-container>
    </mat-option>
  </mat-select>
  <mat-error class="error error-state" *ngIf="hasError('required')">
    {{ type }} is <strong>Required</strong>
  </mat-error>
</mat-form-field>
